/**
 * AUTO-GENERATED FILE - DO NOT EDIT
 * Generated from: foreman.fga
 * Run: pnpm run gen:permissions -- foreman
 */

import type { ModulePermissions } from './types';

export const foremanPermissions = {
  module: 'foreman',
  displayName: 'Foreman',
  entities: [
    {
      name: 'aiChat',
      displayName: 'Ai Chat',
      permissions: [
        { key: 'aiChatRead', action: 'Read', category: 'crud' },
        { key: 'aiChatCreate', action: 'Create', category: 'crud' },
        { key: 'aiChatUpdate', action: 'Update', category: 'crud' },
        { key: 'aiChatDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'aiChatMessage',
      displayName: 'Ai Chat Message',
      permissions: [
        { key: 'aiChatMessageRead', action: 'Read', category: 'crud' },
        { key: 'aiChatMessageSend', action: 'Send', category: 'custom' },
      ],
    },
    {
      name: 'usageMetricsOrg',
      displayName: 'Usage Metrics Org',
      permissions: [
        { key: 'usageMetricsOrgRead', action: 'Read', category: 'crud' },
      ],
    },
  ],
} as const satisfies ModulePermissions;

/**
 * Union type of all permission keys in the Foreman module
 */
export type ForemanPermissionKey =
  | 'aiChatRead'
  | 'aiChatCreate'
  | 'aiChatUpdate'
  | 'aiChatDelete'
  | 'aiChatMessageRead'
  | 'aiChatMessageSend'
  | 'usageMetricsOrgRead';
